import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Message } from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class ToastService {
    private messageSubject: Subject<Message> = new Subject<Message>();

    public sendMessage = (message: Message): void => {
        this.messageSubject.next(message);
    }

    public receiveMessages = (): Observable<Message> => {
        return this.messageSubject;
    }
}
